<div class="summary-wrap container mx-auto shadow-md">
    <div class="summary-title w-100 py-5 px-2 sm:px-5 md:px-5 bg-gray-50">
        <h3 class="text-center sm:text-left text-base sm:text-lg">Slot Date: <span
                class="text-gray-500 tracking-wider font-normal">{{details.slot_start | date:
                'fullDate'}}</span></h3>
    </div>
    <div class="count-wrap w-100">
        <div class="flex justify-between px-2 sm:px-5 md:px-5 items-center my-3">
            <div class="flex items-center text-sm sm:text-base md:text-lg">
                <span class="material-symbols-outlined mr-2">history</span>
                <p class="mx-5">
                    Booked on
                </p>
            </div>
            <div>
                <div class="flex items-center  text-sm sm:text-base md:text-lg">
                    <p class="text-gray-700 m-0 text-right">
                        {{details.booking_date | date:
                        'fullDate'}}
                    </p>
                </div>
            </div>
        </div>
        <div class="flex justify-between px-2 sm:px-5 md:px-5 items-center my-3">
            <div class="flex items-center text-sm sm:text-base md:text-lg">
                <span class="material-symbols-outlined mr-2">schedule</span>
                <p class="mx-5">
                    Slot Time
                </p>
            </div>
            <div>
                <div class="flex items-center text-sm sm:text-base md:text-lg">
                    <p class="text-gray-700 m-0 text-right">
                        {{details.slot_start | date :'shortTime'}} - {{details.slot_end| date :'shortTime'}}
                    </p>
                </div>
            </div>
        </div>
        <mat-divider></mat-divider>
        <div *ngIf="details.no_of_adults > 0" class="flex justify-between px-2 sm:px-5 md:px-5 items-center my-3">
            <div class="flex items-center text-sm sm:text-base md:text-lg">
                <span class="material-symbols-outlined mr-2">man</span>
                <p class="mx-5">
                    Adult
                </p>
            </div>
            <div>
                <!-- <div class="flex items-center">
                    <span class="material-symbols-outlined mr-2">currency_rupee</span>
                    <p class="m-0">
                        {{details.adult_total}}
                    </p>
                </div> -->
                <p class="text-[12px] text-gray-500 m-0 text-right">
                    Count: {{details.no_of_adults}}
                </p>
            </div>
        </div>
        <div *ngIf="details.no_of_childs > 0" class="flex justify-between px-2 sm:px-5 md:px-5 items-center my-3">
            <div class="flex items-center text-sm sm:text-base md:text-lg">
                <span class="material-symbols-outlined mr-2">escalator_warning</span>
                <p class="mx-5">
                    Children
                </p>
            </div>
            <div>
                <div class="flex items-center">
                    <span class="material-symbols-outlined mr-2">currency_rupee</span>
                    <p class="m-0">
                        {{details.child_total}}
                    </p>
                </div>
                <p class="text-[12px] text-gray-500 m-0 text-right">
                    Count: {{details.no_of_childs}}
                </p>
            </div>
        </div>
    </div>
    <div class="flex justify-between px-2 sm:px-5 md:px-5 bg-gray-50 py-3">
        <h3 class="">Total</h3>
        <div class="flex items-center">
            <span class="material-symbols-outlined mr-2">currency_rupee</span>
            <h3 class="m-0">
                {{details.booking_charge}}
            </h3>
            <!-- <h3 class="m-0" *ngIf="details.isRevisit == 1">
                {{details.revisit_charge}}
            </h3> -->
        </div>
    </div>
    <!-- <div class="text-center w-100 py-5">
        <button mat-raised-button color="primary">Continue</button>
    </div> -->
</div>